module.exports = __webpack_public_path__ + "img/Shape.0a511ccf.svg";